import { connect } from "react-redux";
import TableHeaderComponent from "../../../Components/RecordingsManagement/TableComponent/TableHeaderComponent";

const mapStateToProps = (state) => ({
  callFlows: state.reducer.CALL_FLOWS,
  agents: state.reducer.AGENTS,
  agentAIs: state.reducer.AGENT_AIS,
  supervisedAgentDetails: state.reducer.supervisedAgentDetails,
  callFlowsIds: state.reducer.callFlowsIds,
  supervisedAgentIds: state.reducer.supervisedAgentIds,
});

const mapDispatchToProps = (dispatch) => ({});

// Wrap to pass all props including from container AND parent props
const TableHeaderContainer = connect(mapStateToProps, mapDispatchToProps)(TableHeaderComponent);

// Export a wrapper to merge Redux props with component props
export default (props) => <TableHeaderContainer {...props} />;

